import React from 'react'
import { withRouter } from 'react-router'
import PriceListList from '../components/supplier-price-list'
import PriceListProfile from '../components/supplier-price-list/profile'

const SupplierPriceListsPage = ({ match }) => {
    const { priceListId } = match.params
    return priceListId
        ? <PriceListProfile key={priceListId} priceListId={priceListId} />
        : <PriceListList />
}

export default withRouter(SupplierPriceListsPage)



// WEBPACK FOOTER //
// ./src/containers/supplier-price-lists-page.js